import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import AboutPage from "../pages/about/page";
import AirportServicePage from "../pages/services/airport/page";
import WeddingServicePage from "../pages/services/wedding/page";
import CorporateServicePage from "../pages/services/corporate/page";
import CharlestonLocationPage from "../pages/location/charleston/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/about",
    element: <AboutPage />,
  },
  {
    path: "/services/airport-transportation",
    element: <AirportServicePage />,
  },
  {
    path: "/services/wedding-transportation",
    element: <WeddingServicePage />,
  },
  {
    path: "/services/corporate-transportation",
    element: <CorporateServicePage />,
  },
  {
    path: "/location/charleston-sc",
    element: <CharlestonLocationPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
